"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDailyKindList = void 0;
const types_1 = require("../types");
const getDailyKindList = () => {
    return [
        types_1.DAILY_SCHEDULE_KINDS.everyday,
        types_1.DAILY_SCHEDULE_KINDS.weekDays,
        types_1.DAILY_SCHEDULE_KINDS.selectedDays,
    ];
};
exports.getDailyKindList = getDailyKindList;
//# sourceMappingURL=getDailyKindList.js.map